import ViewKomunikatEdytor from "../../components/views/app/konfiguracja/oper/ViewKomunikatEdytor.jsx"

export const komunikatyRoutes = [

    {
        path: '/oper/ustawienia/komunikat',
        exact: true,
        roles: ['konfiguracja_podglad'],
        forbidden: true,
        view: <ViewKomunikatEdytor/>,
        mode: 'any'
    },

]
